import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";

import course04 from "../../../course/course-04/course";
import lesson0424 from "../../../lesson/course-04/lesson-24/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "4285b364-9fa5-4127-a5a7-d5b45a9f0b9b",
    course: {
      id: course04.id,
      slug: course04.slug as string,
      name: course04.name,
      publicId: course04.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course04, lesson0424),
    lesson: lesson0424,
  },
];

export default lessonLinks;
